export const getListBranchMetForActionLog = log => {
  const metBranchListId = log.contextMap.ACCEPTED_LIST_ID;
  if (log.action.metadata.actionType !== 'LIST_BRANCH') {
    console.error(`Non-branch action supplied to 'getListBranchMetForActionLog': ${log.action.metadata.actionType}`);
    return null;
  }
  const actionConnection = log.action.connection;
  const matchingBranch = actionConnection.listBranches.find(branch => branch.listId === metBranchListId);
  const maybeMatchingBranchName = matchingBranch && matchingBranch.branchName;
  return maybeMatchingBranchName || actionConnection.defaultBranchName;
};